// extracted by mini-css-extract-plugin
export var black = "_3b-6";
export var brand = "_3b-1";
export var ddefault = "_3b-0";
export var error = "_3b-3";
export var gray = "_3b-2";
export var highContrast = "_3b-8";
export var outline = "_3b-7";
export var success = "_3b-5";
export var warning = "_3b-4";